import React from 'react';
import {AppBar, Box, Grid, Toolbar, useMediaQuery, useTheme} from "@mui/material";
import DrawerComp from "./DrawerComp";
import logo from '../../../assets/images/logo.png';
import SearchInSite from "../Search/SearchInSite";
import {NavLink} from "react-router-dom";
import ProgressbarOnScroll from "../progressbarOnScroll/ProgressbarOnScroll";
import classes from './Header.module.css'
import {GetState} from "../../../redux/reduxhelper";

const NavItems = [
    {
        id: 1,
        to: "/",
        title: "صفحه اصلی"
    },
    {
        id: 2,
        to: "/Programs/1",
        title: "برنامه ها"
    },
    {
        id: 3,
        to: "/events",
        title: "ایونت ها"
    },
    {
        id: 4,
        to: "/#about_us",
        title: "درباره ما",
    },
    {
        id: 5,
        to: "/contact-us",
        title: "تماس با ما"
    }]

const Header = () => {
    const docLocation = GetState('path_name', '');
    const theme = useTheme()
    const isMatch = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <>
            <Grid container sx={{maxHeight: "100px", position: 'sticky', top: 0, zIndex: 1190}}>
                <AppBar component="nav" sx={{background: "#232536", position: 'relative'}}>
                    <Toolbar
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: "center",
                            gap: 1,
                            minHeight: '64px !important'
                        }}>
                        <Grid display={'flex'} justifyContent={'flex-start'}>
                            {isMatch && <DrawerComp/>}
                            <a href={"https://shadzi.club/"}><img src={logo} alt="logo" width={"80px"}
                                                                  style={{marginRight: '8px'}}/></a>
                            <Box sx={{px: 4, marginRight: "auto", display: {xs: "none", md: "flex"}}}>
                                <Grid sx={{display: 'flex'}} gap={5}>
                                    {
                                        NavItems?.map(item => {
                                            return (
                                                <NavLink className={({isActive}) =>
                                                             isActive && item.to !== '/#about_us' ? `${classes.active} ${classes.navLink}` : classes.navLink
                                                         } key={item.id} to={item.to}>{item.title}</NavLink>
                                            )
                                        })
                                    }
                                </Grid>

                            </Box>
                        </Grid>
                        <SearchInSite/>
                    </Toolbar>
                    <ProgressbarOnScroll
                        color="#7CFC00"
                        gradient={true}
                        height={5}
                        elmStyle={{opacity: 1}}
                        gradientColor="#FF5733"/>
                </AppBar>

            </Grid>
        </>

    );
};

export default Header;



